import React, { FC } from 'react';
import { Body, Button, TrevorIcon } from '@trevor/ui-components';
import styled from 'styled-components';
import { useModal } from '@/features/modals/modalSlice';
import { DeleteInvitedUserModal } from '@/features/dashboard/components/SharePublishEmbedSidebar/components/DeleteInvitedUserModal';

const InvitedUserContainer = styled.div`
  color: var(--color-interface-content-normalº);
  display: flex;
  align-items: center;
  gap: var(--spacing-m);

  > button {
    margin-left: auto;
  }
`;

type InvitedUserProps = {
  email: string;
};

export const InvitedUser: FC<InvitedUserProps> = ({ email }) => {
  const [isModalOpen, handleModalOpen] = useModal();

  return (
    <>
      <InvitedUserContainer key={email}>
        <TrevorIcon name="user" />
        <Body variant={2}>{email}</Body>
        <Button
          size="small"
          variant="secondary"
          icon={<TrevorIcon name="trash-bin" />}
          onClick={handleModalOpen}
        />
      </InvitedUserContainer>
      {isModalOpen && <DeleteInvitedUserModal email={email} />}
    </>
  );
};
